"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _processForwardedAction = _interopRequireDefault(require("../../util/title-actions/processForwardedAction"));

var _HashManager = _interopRequireDefault(require("../../components/common/HashManager"));

var _TitleCard = _interopRequireDefault(require("./TitleCard"));

var _TitleActions = _interopRequireDefault(require("../../title-actions/TitleActions"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _get(target, property, receiver) { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get; } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(receiver); } return desc.value; }; } return _get(target, property, receiver || target); }

function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var he = require('he'); // This assumes that the calling code passes a Backbone.Collection with a model type of Title


var TitleCollectionView =
/*#__PURE__*/
function (_Backbone$View) {
  _inherits(TitleCollectionView, _Backbone$View);

  function TitleCollectionView(_ref) {
    var _this;

    var bus = _ref.bus,
        patronMediaItemsModel = _ref.patronMediaItemsModel,
        View = _ref.View,
        attributes = _ref.attributes,
        coverWidths = _ref.coverWidths,
        isInHero = _ref.isInHero,
        context = _ref.context;

    _classCallCheck(this, TitleCollectionView);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(TitleCollectionView).apply(this, arguments));
    _this._views = [];
    _this.bus = bus;
    _this.View = View || _TitleCard["default"];
    _this.attributes = _.extend({}, attributes);
    _this.coverWidths = coverWidths;
    _this.isInHero = isInHero;
    _this.context = context;
    _this.titleActions = new _TitleActions["default"]({
      bus: _this.bus,
      context: context
    });

    _this.listenTo(_this.collection, 'title:action', _this._handleTitleAction); // TODO: >>> Remove this call and _updateMediaStates() logic and update dependant consumers to use PatronTitleStatus
    // Fetch patron data and trigger state updates.
    // Only fetch patron data if authed and has linked cards.


    if (patronMediaItemsModel && window.OverDrive.isAuthenticated && window.OverDrive.hasLinkedCards) {
      patronMediaItemsModel.initialFetch().then(function (patronData) {
        _this._updateMediaStates(patronData);
      });
    }

    _this.render();

    return _this;
  }

  _createClass(TitleCollectionView, [{
    key: "_handleTitleAction",
    value: function _handleTitleAction(_ref2) {
      var action = _ref2.action,
          model = _ref2.model;
      this.titleActions.perform(action, model);
    }
  }, {
    key: "_updateMediaStates",
    value: function _updateMediaStates(patronData) {
      var _this2 = this;

      var ids = [];

      _(_.values(patronData)).each(function (item) {
        if (_.isArray(item)) {
          var _ids;

          (_ids = ids).push.apply(_ids, _toConsumableArray(item));
        } else if (_.isObject(item)) {
          var _ids2;

          (_ids2 = ids).push.apply(_ids2, _toConsumableArray(_.keys(item).map(Number)));
        } else {
          ids.push(item);
        }
      });

      ids = _.uniq(ids);
      ids.forEach(function (id) {
        var model = _this2.collection.get(id);

        if (model) {
          model.updatePatronState(patronData);
        }
      });

      this._performForwardedAction();
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var frag = document.createDocumentFragment();

      this._views.forEach(function (view) {
        return view.remove();
      });

      this._views = [];
      this.collection.forEach(function (title) {
        title.set('title', he.decode(title.get('title')));
        title.setContext(_this3.context);
        var view = new _this3.View({
          model: title,
          bus: _this3.bus,
          coverWidths: _this3.coverWidths,
          isInHero: _this3.isInHero
        });
        frag.appendChild($('<li />', {
          "class": 'js-titleCard Item'
        }).append(view.$el)[0]);

        _this3._views.push(view);
      });

      if (!window.featureManager.isEnabled('stopStealingCollectionTitle')) {
        // I think we never noticed this odd logic because in most cases where this view is used the selector
        // below doesn't match anything on the page.
        var $collectionTitle = $('.collection-title-container');
        this.$el.attr(this.attributes);
        this.$el.empty().append($collectionTitle).append(frag);
      } else {
        this.$el.attr(this.attributes);
        this.$el.empty().append(frag);
      }
    }
  }, {
    key: "remove",
    value: function remove() {
      this._views.forEach(function (view) {
        return view.remove();
      });

      _get(_getPrototypeOf(TitleCollectionView.prototype), "remove", this).call(this);
    }
  }, {
    key: "_performForwardedAction",
    value: function _performForwardedAction() {
      if (window.OverDrive.isAuthenticated && window.OverDrive.hasLinkedCards && _HashManager["default"].get('action')) {
        var forwardedAction = new _processForwardedAction["default"](this.collection, this.bus);
        forwardedAction.executeAction();
        window.forwardedAction = forwardedAction;
      }
    }
  }, {
    key: "tagName",
    get: function get() {
      return 'ul';
    }
  }]);

  return TitleCollectionView;
}(Backbone.View);

exports["default"] = TitleCollectionView;